@if (loading()) {
  <se-fe-spinner [seFeDataSize]="900" [seFeDataCenter]="true"></se-fe-spinner>
} @else {
  <div>
    @if (showSearch() && !isZeroState()) {
      <div class="product-table-toolbar-container">
        <se-fe-toolbar
          class="product-table-toolbar"
          [seFeDataQuery]="query() || ''"
          (seFeQueryChange)="handleSearch($event)">
          <ng-content select="[productTableToolbarActions]"></ng-content>

          @if (showToolbarFilters()) {
            <se-fe-icon-button seFeToolbarActions class="product-table-filter-button" (click)="toggleFilterMenu()">
              <se-fe-icon
                seFeDataName="filter_list"
                seFeDataSize="600"
                seFeDataColor="default"
                [seFeDataAriaLabel]="'Filters'"></se-fe-icon>
            </se-fe-icon-button>
          }
        </se-fe-toolbar>

        @if (showToolbarFilters() && filterMenuOpen()) {
          <product-table-filters
            [title]="filterMenuTitle()"
            [active]="active()"
            [catalogId]="catalogId()"
            [showCatalogFilter]="showCatalogFilter()"
            [catalogFilterOptions]="catalogFilterOptions()"
            (filtersApplied)="handleFiltersApplied($event)"></product-table-filters>
        }
      </div>
    }

    @if (products() && products()!.length > 0 && datasource()) {
      <div [formGroup]="form">
        <se-fe-table-wrapper class="product-list-table-wrapper">
          <table
            seFeTable
            [seFeTableSort]="initialSort()"
            [attr.title]="tableTitle()"
            style="max-height: 400px"
            class="product-list-table"
            [dataSource]="datasource()"
            (seFeSortChange)="sortChange($event)">
            <ng-container seFeColumnDef="Select">
              <th seFeHeaderCell *seFeHeaderCellDef>
                <se-fe-checkbox formControlName="selectAll" [seFeDataOptions]="selectAllOptions"></se-fe-checkbox>
              </th>
              <td seFeCell *seFeCellDef="let row">
                <se-fe-checkbox
                  [formControlName]="getRowId(row)"
                  [seFeDataOptions]="rowSelectionOptions"></se-fe-checkbox>
              </td>
            </ng-container>
            <ng-container seFeColumnDef="Name">
              <th class="table-header" seFeHeaderCell *seFeHeaderCellDef seFeDataRef="name" seFeTableSortHeader>
                {{ nameColumnLabel() }}
              </th>
              <td class="table-row" seFeCell *seFeCellDef="let row">
                <product-name-cell [product]="row" [link]="getProductLink(row)" [target]="target"></product-name-cell>
              </td>
            </ng-container>
            <ng-container seFeColumnDef="Active">
              <th class="table-header" seFeHeaderCell *seFeHeaderCellDef seFeDataRef="active" seFeTableSortHeader>
                Status
              </th>
              <td class="statusColumn" seFeCell *seFeCellDef="let row">
                <product-status-cell [product]="row"></product-status-cell>
              </td>
            </ng-container>
            <ng-container seFeColumnDef="Price">
              <th class="table-header" seFeHeaderCell *seFeHeaderCellDef seFeDataRef="price" seFeTableSortHeader>
                Price
              </th>
              <td class="table-row" seFeCell *seFeCellDef="let row">
                <product-price-cell [price]="getProductPrice(row)"></product-price-cell>
              </td>
            </ng-container>
            <ng-container seFeColumnDef="Delete">
              <th seFeHeaderCell *seFeHeaderCellDef></th>
              <td seFeCell *seFeCellDef="let row">
                @if (showRemove()) {
                  <se-fe-icon-button (click)="removeProductRow(row)">
                    <se-fe-icon
                      seFeDataName="close"
                      seFeDataSize="500"
                      [seFeDataAriaLabel]="'Remove ' + row.name + ' from catalog'"
                      seFeDataColor="default"></se-fe-icon>
                  </se-fe-icon-button>
                } @else if (mode() === 'productList') {
                  <se-fe-icon-button (click)="deleteProductRow(row)">
                    <se-fe-icon
                      seFeDataName="trash"
                      seFeDataSize="500"
                      seFeDataAriaLabel="Delete product"
                      seFeDataColor="gray-700"></se-fe-icon>
                  </se-fe-icon-button>
                }
              </td>
            </ng-container>
            <tr seFeHeaderRow *seFeHeaderRowDef="displayedColumns()"></tr>
            <tr [seFeRow]="row" *seFeRowDef="let row; columns: displayedColumns()"></tr>
          </table>
        </se-fe-table-wrapper>
      </div>
    } @else if (hasQueryOrFiltersApplied() || isNoResultsZeroState()) {
      <se-fe-empty-state class="empty-state" [seFeDataTitle]="emptyStateTitle()"></se-fe-empty-state>
    } @else if (isProductZeroState()) {
      <se-fe-empty-state class="empty-state" seFeDataTitle="You don't have any products yet">
        <se-fe-icon
          seFeEmptyStateIcon
          seFeDataName="store_thin"
          seFeDataSize="950"
          seFeDataColor="default"
          seFeDataAriaLabel="product management store icon"></se-fe-icon>
        <p>
          Create products your organization offers to sell to members during registration. For example, add a "Team
          Jersey" or "Soccer Ball" that members can purchase at checkout.
        </p>
        <a se-fe-button seFeEmptyStateAction [routerLink]="createProductLink()" [target]="target">Create product</a>
      </se-fe-empty-state>
    } @else if (isCatalogZeroState()) {
      @if (isBundleMode()) {
        <se-fe-empty-state class="empty-state" seFeDataTitle="Add bundles to this catalog">
          <se-fe-icon
            seFeEmptyStateIcon
            seFeDataName="spot_pricetag"
            seFeDataSize="950"
            seFeDataColor="default"
            seFeDataAriaLabel="catalog bundle icon"></se-fe-icon>
          <p>
            Add bundles to group products and offer them at a set price in this catalog. For example, create a "Season
            Starter" that includes a jersey, shorts, and socks.
          </p>
          <button se-fe-button seFeEmptyStateAction (click)="chooseCatalogItems.emit($event.currentTarget)">
            Choose bundles
          </button>
        </se-fe-empty-state>
      } @else {
        <se-fe-empty-state class="empty-state" seFeDataTitle="Add products to this catalog">
          <se-fe-icon
            seFeEmptyStateIcon
            seFeDataName="store_thin"
            seFeDataSize="950"
            seFeDataColor="default"
            seFeDataAriaLabel="catalog product icon"></se-fe-icon>
          <p>
            Add products to this catalog to sell during registration. For example, add a "Team Jersey" or "Soccer Ball"
            that members can purchase at checkout.
          </p>
          <button se-fe-button seFeEmptyStateAction (click)="chooseCatalogItems.emit($event.currentTarget)">
            Choose products
          </button>
        </se-fe-empty-state>
      }
    } @else {
      <se-fe-empty-state class="empty-state" seFeDataTitle="You don't have any bundles yet">
        <se-fe-icon
          seFeEmptyStateIcon
          seFeDataName="spot_pricetag"
          seFeDataSize="950"
          seFeDataColor="default"
          seFeDataAriaLabel="product management store icon"></se-fe-icon>
        <p>
          Create bundles to group products and offer them at a set price. For example, create a "Season Starter" that
          includes a jersey, shorts, and socks.
        </p>
        <a se-fe-button seFeEmptyStateAction [routerLink]="createBundleLink()" [target]="target">Create bundle</a>
      </se-fe-empty-state>
    }

    @if (products()?.length && paginationEnabled()) {
      <se-fe-pagination
        [seFeDataPaginationOptions]="paginationOptions()"
        (seFePaginationChange)="paginationChange($event)"></se-fe-pagination>
    }
  </div>
}
